export default "__VITE_ASSET__Bj862DJI__"